<app-pop-up>
  <app-loader [hidden]="!showLoader"></app-loader>
    <app-pop-up-header
      [headerName]="'Update'"
      (close)="closePopup()"
    ></app-pop-up-header>

    <app-pop-up-body>
      <app-search-user-with-role
        [labelName]="labelName"
        [users]="usersList"
        [inputFormControl]="profileForm?.controls?.user"
        [placeHolder]="'Search'"
        (onSelectUser)="getSelectedUser($event)"
      ></app-search-user-with-role>
      <div class="other-text">By updating, you have changed assignments or have made adjustments to the data entry field in the current workflow and want to update the workflow while keeping existing data entered.</div>
    </app-pop-up-body>

    <app-pop-up-footer>
        <app-button
        [name]="'Cancel'"
        [type]="'outlined'"
        (btnClick)="closePopup()"
      ></app-button>
      <app-button
        [name]="'Update'"
        [type]="'primary'"
        (btnClick)="update()"
        [disable]="!selectedUserDetail"
      ></app-button>
    </app-pop-up-footer>
  </app-pop-up>
